import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

import { ReengageAuditRoutingModule } from './reengage-audit-routing.module';
import { ReengageAuditComponent } from './reengage-audit.component';

@NgModule({
  declarations: [ReengageAuditComponent],
  imports: [
    FormsModule,
    CommonModule,
    ReengageAuditRoutingModule,
    NzSpinModule,
    NzInputModule,
    NzButtonModule,
    NzIconModule,
    NzDividerModule,
    NzTableModule,
    NzTagModule,
    NzGridModule,
    NzDropDownModule,
    NzCheckboxModule,
    NzDrawerModule,
    NzCollapseModule,
  ],
})
export class ReengageAuditModule {}
